/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';

const usePreventImageDrag = (containerRef: React.RefObject<HTMLDivElement>) => {
    useEffect(() => {
        const onDragStart = (event: DragEvent) => event.preventDefault();

        if (containerRef.current) {
            containerRef.current.addEventListener('dragstart', onDragStart);
        }
        return () => {
            if (containerRef.current) {
                containerRef.current.removeEventListener(
                    'dragstart',
                    onDragStart
                );
            }
        };
    }, [containerRef]);
};

export default usePreventImageDrag;
